/** @jsx h */
import { h } from 'preact'

const Capsule = props => {
  const { label, small, shadow } = props
  const variantClass = small ? 'small' : 'large'

  return (
    <div
      class={`ClaimCapsule ClaimCapsule--${variantClass} ClaimCapsule--${shadow}`}
    >
      <h2 class={`ClaimCapsule-title ClaimCapsule-title--${variantClass}`}>
        {label}
      </h2>
    </div>
  )
}

Capsule.defaultProps = {
  small: false,
  shadow: 'noShadow'
}

export default Capsule
